// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__3L3hp","dark":"dark__3nM5L","white":"white__2tcJH","header-logo":"header-logo__29x3c","text":"text__2ZUa-","header_sub_title":"header_sub_title__lycET"};